module.exports = __webpack_public_path__ + "media/assets/images/icon-download-c656c7c447571b96bd38ffbc528eaf13.png";